var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63876 9.3125H5.4415V15.875H2.51181V9.3125H0.109465V6.61719H2.51181V4.53711C2.51181 2.19336 3.91806 0.875 6.05673 0.875C7.08212 0.875 8.16611 1.08008 8.16611 1.08008V3.39453H6.96493C5.79306 3.39453 5.4415 4.09766 5.4415 4.85938V6.61719H8.04892L7.63876 9.3125Z",
    fill: "#050B20"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/PzQUNVEIeMrv8HjdXbjYra?node-id=13-779"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 0.154875,
    y: -1.125,
    width: 9.375,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.641be62a95817eabac84c1d19b38c437.svg";
export { ForwardRef as ReactComponent };